import { useEffect, useRef } from "react";

const Intro = () => {
  const infoPanelRef = useRef();
  const infoModelRef = useRef();

  useEffect(() => {
    const checkPointerLock = () => {
      if (document.pointerLockElement) {
        infoModelRef.current.style.display = "none";
        infoPanelRef.current.style.height = "7rem";
        infoPanelRef.current.style.width = "6rem";
      }
    };
    document.addEventListener("pointerlockchange", checkPointerLock);
    return () => {
      document.removeEventListener("pointerlockchange", checkPointerLock);
    };
  }, []);

  return (
    <div
      ref={infoPanelRef}
      aria-hidden="true"
      className="overflow-y-auto overflow-x-hidden fixed bottom-0 left-0 z-[200] justify-center flex items-center w-full h-full pb-28"
    >
      <div
        ref={infoModelRef}
        className="p-6 w-full max-w-lg bg-[#ffffff75] border-2 border-white rounded-lg"
      >
        <p className="text-base leading-relaxed text-[#3E3232]">
          💐 <span className="font-bold">Happy Mother’s Day!</span> 💐
          <br />
          <br />
          This space is a small tribute to the most amazing woman I know — my mom.
          <br />
          Through every role she’s played — mother, teacher, chef, poet, artist, and so much more — she’s been a constant light in my life.
          <br />
          <br />
          🌼 May this page reflect even a fraction of the love and beauty she brings into the world every day.
          <br />
          🕊️ Feel free to explore and experience this tribute made with all my heart.
          <br />
          <br />
          <span className="text-center block">
            💖 Click the "?" button at the bottom-left to revisit this message anytime.
          </span>
        </p>
      </div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          infoModelRef.current.style.display = "block";
          infoPanelRef.current.style.height = "100%";
          infoPanelRef.current.style.width = "100%";
        }}
        className="p-1 bg-[#ffffff44] absolute bottom-[20px] left-[30px] border-2 border-white rounded-full"
      >
        <img className="w-8 h-8" src="./question.svg" />
      </button>
    </div>
  );
};

export default Intro;
